/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-07-06 16:23:08
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-11 19:55:22
 */
import request from '@/utils/request';
import { AjaxMethod } from '@/utils/dataMap';

export const uploadCdnInfo = params => {
	return request({
		url: '/upload/cdn-info/',
		params: params,
		method: AjaxMethod.get,
	});
};

export const checkFollow = params => {
	return request({
		url: '/api/common/check-follow-wx',
		params: params,
		method: AjaxMethod.get,
	});
};
//根据用户是否微信授权显示功能升级提示框
export const checkUpNotice = (params, notOrigin = true) => {
	return request({
		url: 'api/account/check-bind-super',
		params,
		method: AjaxMethod.get,
		notOrigin,
	});
};
//用户信息
export const accountInfo = params => {
	return request({
		url: '/api/team-manage/user-detail',
		params: params,
		method: AjaxMethod.get,
	});
};

export const getBaseInfo = () => {
	return request({
		url: '/api/system/get-base-info',
		method: AjaxMethod.post,
	});
};

export const actCategoryList = params => {
	return request({
		url: '/api/activity/category-list',
		params: params,
		method: AjaxMethod.get,
		// mock: true,
	});
};
// 接口迁移至 shopManage.talCategoryList
export const talCategoryList = params => {
	return request({
		url: '/api/talent/category-list',
		params: params,
		method: AjaxMethod.get,
	});
};

// 获取二级类目 迁移至 /api/product-info/category-list-v1
export const getCategoryList = params => {
	return request({
		url: '/api/product-info/category-list-v1',
		params,
		method: AjaxMethod.get,
	});
};

export const teamConf = params => {
	return request({
		url: '/api/account/team-conf',
		params: params,
		method: AjaxMethod.get,
	});
};

// 自动识别地址
export const getAddress = params => {
	return request({
		url: '/api/common/get-address',
		data: params,
		method: AjaxMethod.post,
	});
};

// 弹框展示一次
export const getPopupAdOne = params => {
	return request({
		url: '/api/team-conf/get-popup-ad-one',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

// 部门权限
export const managerDept = params => {
	return request({
		url: 'api/team-manage/list',
		params,
		method: AjaxMethod.get,
	});
};

export const getQrCodeImg = params => {
	return request({
		url: '/api/account/qr-link',
		params: params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//团长收货地址列表
export const addressManageList = params => {
	return request({
		url: '/api/second-institution/delivery-info-list',
		params: params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//团长收货地址 设置为使用状态
export const addressManageSetUsed = params => {
	return request({
		url: '/api/second-institution/set-used-delivery-info',
		params: params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//团长收货地址 设置默认值
export const addressManageSetDefault = params => {
	return request({
		url: '/api/second-institution/set-default-delivery-info',
		params: params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//删除团长地址
export const addressManageDelete = params => {
	return request({
		url: '/api/second-institution/del-delivery-info',
		params: params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};
// 设置自定义字段显示
export const setFieldShow = data => {
	return request({
		url: '/api/layout/set-field-show',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 获取自定义字段显示
export const getFieldShow = params => {
	return request({
		url: '/api/layout/get-field-show',
		params,
		method: AjaxMethod.get,
	});
};

// 获取默认筛选设置条件
export const getPageField = params => {
	return request({
		url: '/api/layout/get-page-field',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};
// 默认筛选设置删除
export const delPageField = params => {
	return request({
		url: '/api/layout/del-page-field',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

// 获取小程序分享卡片icon，name
export const getMiniAppF = params => {
	return request({
		url: '/api/account/get-mini-app-conf',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};
// oss通过sts方式获取临时密钥
export const getOssSign = data => {
	return request({
		url: '/micro-cyt/oss/sts',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 标签管理 批量保存或更新
export const batchSaveOrUpdate = data => {
	return request({
		url: '/micro-cyt/tag/batch-save-or-update',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
// 消息已读
export const readMessage = params => {
	return request({
		url: 'api/team-conf/close-popup-ad',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

export const getHotFreshList = params => {
	return request({
		url: '/miniprogram-batch-nestjs/hot-fresh/config/list',
		params,
		method: AjaxMethod.get,
		timeout: 2000,
	});
};

// 团长打开链接
export const cooperateLinkCheck = params => {
	return request({
		url: '/api/cooperate-link/check',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

// 团长打开链接校验密码
export const cooperateLinkCheckPwd = data => {
	return request({
		url: '/api/cooperate-link/check-pwd',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 协作去绑定
export const doCooperateBind = data => {
	return request({
		url: '/api/cooperate/do-cooperate-bind',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 新手引导
export const cooperateInductionTip = data => {
	return request({
		url: '/api/cooperate/induction-tip',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 检查是否绑定合作店铺
export const checkBindCooperativeShop = data => {
	return request({
		url: '/api/cooperative-shop/check-bind',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
